import style from './wallex.module.scss';
import Image from 'next/image';
import { InView } from 'react-intersection-observer';
import CryptoItem from './crypto-block/crypto';
import WallexTitle from './wallex-block/wallex-title/wallex-title';
import WallexSubtext from './wallex-block/wallex-subtext/wallex-subtext';
import WallexTitleTwo from './wallex-block/wallex-title-2/wallex-title-2';
import WallexCategoryList from './wallex-block/wallex-category-list/wallex-category-list';
import WallexBlock from './wallex-block/wallex-block';
import Accordion from './wallex-accordion/accordion';
import WallexTechnologyItem from './wallex-technology/wallex-technology';
import CryptoArrow from './crypto-block/crypto-arrow/crypto-arrow';
import WallexText from './wallex-block/wallex-text/wallex-text';
import { useEffect } from 'react';
import animations from '@styles/animations.module.scss';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import { Themes } from '@layouts/main-layout/themes.enum';

const state = {
  item_1: {
    id: '38',
    title: 'Wallex App',
    subtitle: 'An innovative e-wallet for safe and convenient cryptocurrency management.',
  },
  item_3: {
    id: '39',
    text: 'Wallex App is an easy-to-use digital crypto-wallet. It is designed for the most efficient management of any cryptocurrency. Users can safely store bitcoins and other cryptocurrencies and perform various transactions and exchange operations with them.',
    text2:
      'The app principle is simple: you create an e-wallet for each cryptocurrency and get the opportunity to manage your funds in an intuitive way and with just a few taps. No extra steps are required!',
  },
  item_4: {
    id: '40',
    title: 'Project info',
  },
  item_5: {
    id: '41',
    title: 'How the Story Begins',
    text: [
      {
        id: '1',
        text: "However, nowadays, having only a website isn't enough to effectively operate a digital business. Therefore, at the Client's request, we proceeded with the cryptocurrency app development project.",
      },
      {
        id: '2',
        text: 'It all started when the Client entrusted us to design and develop a landing page. After that, since the results of our work completely satisfied him, he also ordered us to create a fully functional website.',
      },
    ],
  },
  item_6: {
    id: '42',
    title: 'Team Working on the Project',
    text: [
      {
        id: '3',
        text: 'Several Agilie departments had been working closely on the Wallex project. We involved web and mobile developers, QA engineers, and, of course, UI/UX experts in the app creation.',
      },
      {
        id: '4',
        text: 'The working process itself was supervised by Sergey Melashich, our senior developer.',
      },
    ],
  },
  item_7: {
    id: '43',
    title: 'UI/UX Challenges & Ideas',
    text: [
      {
        id: '5',
        text: 'We developed the app’s UI/UX from scratch. And the main challenge was to provide the best user experience.',
      },
      {
        id: '6',
        text: "That's why we've resorted to the logic that is most typical for the e-wallet's design. This made the application interface intuitive and user-friendly.",
      },
      {
        id: '7',
        text: "As for the choice of a color scheme, we were guided by both the Client's wishes and the users' expectations.",
      },
    ],
  },
  accordion: {
    id: '44',
    title: 'Development Challenges to Overcome',
    subtitle:
      "However, nowadays, having only a website isn't enough to effectively operate a digital business. Therefore, at the Client's request, we proceeded with the cryptocurrency app development project.",
  },
  technology: {
    id: '45',
    title: 'Technology Stack Used',
    items: [
      {
        id: '8',
        name: 'Nrwl',
        img: '/wallex-images/technology-icons/nrwl.png',
        imageHeight: 16,
        imageWidth: 24,
      },
      {
        id: '9',
        name: 'TypeScript',
        img: '/wallex-images/technology-icons/typescript.png',
        imageHeight: 24,
        imageWidth: 24,
      },
      {
        id: '10',
        name: 'NativeScript',
        img: '/wallex-images/technology-icons/nativescript.png',
        imageHeight: 24,
        imageWidth: 24,
      },
      {
        id: '11',
        name: 'Angular',
        img: '/wallex-images/technology-icons/angular.png',
        imageHeight: 24,
        imageWidth: 22,
      },
      {
        id: '12',
        name: 'NestJS',
        img: '/wallex-images/technology-icons/nestjs.png',
        imageHeight: 24,
        imageWidth: 24,
      },
      {
        id: '13',
        name: 'PostgreSQL',
        img: '/wallex-images/technology-icons/postgresql.png',
        imageHeight: 24,
        imageWidth: 24,
      },
      {
        id: '14',
        name: 'Redis',
        img: '/wallex-images/technology-icons/redis.png',
        imageHeight: 24,
        imageWidth: 24,
      },
    ],
  },
  previewBlock: [
    {
      id: '15',
      title: 'Home Screen',
      text: [
        {
          id: '16',
          text: "The app's home screen displays the most meaningful data, which is the state of the user’s financial account. And the first thing that catches his eye is the total balance in US dollars.",
        },
        {
          id: '17',
          text: 'Also, the user sees all his crypto-wallets with an indication of the monetary balance on each one. So he gets an idea of his financial status at a glance.',
        },
      ],
      img: '/wallex-images/mockup1.png',
      alt: 'cryptocurrency App Development',
    },
    {
      id: '46',
      title: 'Transaction Details',
      text: [
        {
          id: '47',
          text: 'Our application guarantees the best user experience, and therefore any cryptocurrency transaction is simple, clear, and transparent.',
        },
        {
          id: '48',
          text: 'Among other things, the user is able to access the details of his transactions and see the status of each one. Also, this feature allows him to understand which of them have been successful and which have failed.',
        },
      ],
      img: '/wallex-images/mockup2.png',
      alt: 'digital crypto-wallet',
    },
    {
      id: '18',
      title: 'Exchange',
      text: [
        {
          id: '19',
          text: "Do you need to exchange cryptocurrency? It's easy! Our application will help you with this.",
        },
        {
          id: '20',
          text: 'The Wallex app supports all popular cryptocurrencies. And you can freely exchange your funds and move them from one e-wallet to another depending on the type of cryptocurrency.',
        },
      ],
      img: '/wallex-images/mockup3.png',
      alt: 'create an e-wallet',
    },
    {
      id: '21',
      title: 'Sending cryptocurrency',
      text: [
        {
          id: '22',
          text: 'The main task of cryptocurrency app development is to create a digital wallet with the ability to send your funds to other users. Undoubtedly, the feature belongs to the key ones.',
        },
        {
          id: '23',
          text: 'Our Wallex app allows you to do this quickly and safely. The whole process takes a minimum of time.',
        },
      ],
      img: '/wallex-images/mockup4.png',
      alt: 'cryptocurrency app development project',
    },
    {
      id: '24',
      title: 'Settings',
      text: [
        {
          id: '25',
          text: 'And the last feature making our digital wallet so convenient is the Settings.',
        },
        {
          id: '26',
          text: 'You can change the password, passcode, and other parameters as needed. And of course, there is an opportunity to use the Contact Us form at any time you want.',
        },
      ],
      img: '/wallex-images/mockup5.png',
      alt: 'cryptocurrency app development process',
    },
  ],
  cryptoBlock: {
    id: '49',
    Bitcoin: {
      id: '27',
      title: 'Bitcoin',
      subtitle: 'BTC',
      img: '/wallex-images/ic-bitcoin.svg',
      alt: 'best crypto wallets',
    },
    BitcoinCash: {
      id: '28',
      title: 'Bitcoin Cash',
      subtitle: 'BCH',
      img: '/wallex-images/ic-bitcoincash.svg',
      alt: 'cryptocurrency app development process',
    },
    USDS: {
      id: '29',
      title: 'USDST',
      subtitle: 'USDST',
      img: '/wallex-images/ic-usds.svg',
      alt: 'cryptocurrency app development project',
    },
    GBPS: {
      id: '30',
      title: 'GBPST',
      subtitle: 'GBPST',
      img: '/wallex-images/ic-gbps.svg',
      alt: 'create an e-wallet',
    },
    Stellar: {
      id: '31',
      title: 'Stellar',
      subtitle: 'XLM',
      img: '/wallex-images/ic-stellar.svg',
      alt: 'digital crypto-wallet',
    },
    Ethereum: {
      id: '32',
      title: 'Ethereum',
      subtitle: 'ETH',
      img: '/wallex-images/ic-ethereum.svg',
      alt: 'cryptocurrency App Development',
    },
    EURS: {
      id: '33',
      title: 'EURST',
      subtitle: 'EURST',
      img: '/wallex-images/ic-eurs.svg',
      alt: 'cryptocurrency wallet',
    },
  },
  cryptoBlockHeader: {
    id: '50',
    title: 'Receiving cryptocurrency',
    text: {
      id: '34',
      text: [
        'In addition to sending and exchanging cryptocurrencies, our application helps you with receiving funds from other users.',
        'As you can see, everything is thought-out to the very smallest detail.',
      ],
    },
    arrows: [
      {
        id: '35',
        img: '/wallex-images/arrow.svg',
      },
      {
        id: '36',
        img: '/wallex-images/arrow-red.svg',
      },
      {
        id: '37',
        img: '/wallex-images/arrow-circle.svg',
      },
    ],
  },
  qouteBlock: {
    id: '51',
    qoute:
      'Wallex App is a multi-digital wallet aimed at helping users store, receive, send, convert, and perform other similar cryptocurrency manipulations.',
    qouteShape: '/wallex-images/qoute-shape.svg',
    title: 'Simone Mazzuca',
    subtitle: 'Wallex, Founder',
    img: '/wallex-images/avatar.png',
    alt: 'create a digital wallet',
  },
};

interface WallexProjectProps {
  breadcrumbsText: string;
}

const RANGE = 1000;

const WallexComponent = ({ breadcrumbsText }: WallexProjectProps) => {
  let wallexSliderImageBlack = '/wallex-images/black-iphone.png';
  let wallexSliderImageWhite = '/wallex-images/white-iphone.png';
  let wallexSliderImageBlackTablet = '/wallex-images/black-iphone-tablet.png';
  let wallexSliderImageWhiteTablet = '/wallex-images/white-iphone-tablet.png';
  let wallexSliderImageBlackMobile = '/wallex-images/black-iphone-mobile.png';
  let wallexSliderImageWhiteMobile = '/wallex-images/white-iphone-mobile.png';

  useEffect(() => {
    const ranger = document.getElementById('ranger') as HTMLInputElement;
    const imageContainer: HTMLElement = document.getElementById('container') as HTMLElement;
    const upperImage: HTMLElement = document.getElementById('upperImage') as HTMLElement;
    const upperImage2: HTMLElement = document.getElementById('upperImage2') as HTMLElement;
    const upperImage3: HTMLElement = document.getElementById('upperImage3') as HTMLElement;
    //default value for range
    ranger.value = String(RANGE / 2);
    resizeImage();

    ranger.onchange = resizeImage;
    ranger.oninput = resizeImage;
    ranger.ontouchmove = resizeImage;
    window.onresize = resizeImage;

    function resizeImage() {
      const imageWidth = imageContainer.offsetWidth;
      const rangerWidth = ranger.offsetWidth - 40;
      const pixelsInValue = rangerWidth / RANGE;
      const gapInPixels = (rangerWidth - imageWidth) / 2;
      const gapInValues = gapInPixels / pixelsInValue;
      // if (ranger.value < gapInValues || ranger.value > gapInValues + imageWidth / pixelsInValue) {
      //     return;
      // }

      const value = (Number(ranger.value) - gapInValues) * pixelsInValue;
      if (document.body.offsetWidth > 1200) {
        upperImage.style.clipPath = `polygon(0 0, ${value}px 0, ${value}px 100%, 0 100%)`;
      }
      if (document.body.offsetWidth <= 1200) {
        upperImage2.style.clipPath = `polygon(0 0, ${value}px 0, ${value}px 100%, 0 100%)`;
      }
      if (document.body.offsetWidth <= 768) {
        upperImage3.style.clipPath = `polygon(0 0, ${value}px 0, ${value}px 100%, 0 100%)`;
      }
    }
  }, []);

  return (
    <>
      <Breadcrumbs theme={Themes.Dark} lastElementTitle={breadcrumbsText} />
      <div className={style.wallex__container}>
        <div className={style.wallex__block__head}>
          <div className={style.wallex__block__head_margin}>
            <WallexTitle state={state.item_1.title} />
          </div>
          <WallexSubtext state={state.item_1.subtitle} />
        </div>

        <InView triggerOnce={true}>
          {({ inView, ref, entry }) => {
            if (inView) {
              entry?.target.classList.add(animations.active);
            }
            return (
              <div key="range" ref={ref} className={`${style.wallex__main} ${animations.scroll__animation}`}>
                <div className={style.slider__container} id="container">
                  <div className={`${style.slider_desktop}`}>
                    <Image sizes="800px" layout={'fill'} src={wallexSliderImageBlack} alt="black" />
                    <div className={style.slider__image_white}>
                      <Image sizes="800px" layout={'fill'} src={wallexSliderImageWhite} alt="white" id="upperImage" />
                    </div>
                  </div>
                  <div className={`${style.slider_tablet} ${style.slider__container}`}>
                    <Image sizes="800px" layout={'fill'} src={wallexSliderImageBlackTablet} alt="black" />
                    <div className={style.slider__image_white}>
                      <Image
                        sizes="800px"
                        layout={'fill'}
                        src={wallexSliderImageWhiteTablet}
                        alt="white"
                        id="upperImage2"
                      />
                    </div>
                  </div>
                  <div className={`${style.slider_mobile} ${style.slider__container}`}>
                    <Image sizes="800px" layout={'fill'} src={wallexSliderImageBlackMobile} alt="black" />
                    <div className={style.slider__image_white}>
                      <Image
                        sizes="800px"
                        layout={'fill'}
                        src={wallexSliderImageWhiteMobile}
                        alt="white"
                        id="upperImage3"
                      />
                    </div>
                  </div>
                </div>
                <label>
                  <input type="range" className={style.slider__ranger} id="ranger" min="0" max={RANGE} />
                </label>
                <svg className={style.wallex__main__circle} width="865" height="865" viewBox="0 0 865 865">
                  <circle className={style.wallex__main__circle_first} cx="432" cy="432" r="430" />
                  <circle className={style.wallex__main__circle_second} cx="432" cy="432" r="310" />
                  <circle className={style.wallex__main__circle_third} cx="432" cy="432" r="230" />
                </svg>
                <div className={`${style.wallex__main__coin__item} ${style.wallex__main__coin__item__send}`}>
                  <Image alt="sendCoin" src={'/wallex-images/coin-1.png'} layout={'fill'} />
                </div>
                <div className={`${style.wallex__main__coin__item} ${style.wallex__main__coin__item__receive}`}>
                  <Image alt="receive" src={'/wallex-images/coin-2.png'} layout={'fill'} />
                </div>
                <div className={`${style.wallex__main__coin__item} ${style.wallex__main__coin__item__exchange}`}>
                  <Image alt="exchange" src={'/wallex-images/coin-3.png'} layout={'fill'} />
                </div>
              </div>
            );
          }}
        </InView>
        <div className={`${style.wallex__block}`}>
          <div className={`${style.wallex__text__block} `}>
            <WallexTitleTwo isTitle={true} state={state.item_3.text} />
          </div>
          <WallexTitleTwo isTitle={true} state={state.item_3.text2} />
        </div>
        <hr />

        <div className={style.wallex__block__list}>
          <div className={`${style.wallex__block__title}`}>
            <WallexTitle size={'md'} state={state.item_4.title} />
          </div>
          <WallexCategoryList />
        </div>
        <hr />
        <WallexBlock state={state.item_5} />
        <hr />
        <WallexBlock state={state.item_6} />
        <hr />
        <WallexBlock state={state.item_7} />
        <hr />
        <div className={style.wallex__accordion}>
          <div className={style.wallex__accordion__header}>
            <div className={`${style.wallex__accordion__title} `}>
              <WallexTitle size={'md'} state={state.accordion.title} />
            </div>
            <WallexText state={state.accordion.subtitle} />
          </div>
          <div className={`${style.wallex__accordion__body} `}>
            <Accordion />
          </div>
        </div>
        <hr />
        <div className={style.wallex__technology__block}>
          <div className={`${style.wallex__technology__title} `}>
            <WallexTitle size={'md'} state={state.technology.title} />
          </div>
          <div className={`${style.wallex__technology}`}>
            {state.technology.items.map((item: any) => {
              return <WallexTechnologyItem key={item.id} state={item} />;
            })}
          </div>
        </div>
        <hr />
        <div className={style.preview__block}>
          {state.previewBlock.map((item: any, index: number) => {
            return (
              <div key={item.id}>
                <div className={index % 2 === 0 ? style.preview : `${style.preview_reversed} ${style.preview}`}>
                  <div className={style.preview__text}>
                    <div className={style.preview__title}>
                      <WallexTitle size={'md'} state={item.title} />
                    </div>
                    {item.text.map((item: any) => {
                      return (
                        <div key={item.id} className={style.preview__text__block}>
                          <WallexText state={item.text} />;
                        </div>
                      );
                    })}
                  </div>

                  <div className={`${style.preview__image}`}>
                    <InView triggerOnce={true}>
                      {({ inView, ref, entry }) => {
                        if (inView) {
                          entry?.target.classList.add(animations.active);
                        }
                        return (
                          <div className={`${animations.scroll__animation} ${style.preview__image}`} ref={ref}>
                            <Image layout="fill" src={item.img} alt={item.alt} />
                          </div>
                        );
                      }}
                    </InView>
                  </div>
                </div>
                <hr />
              </div>
            );
          })}
        </div>

        <div className={style.wallex__crypto}>
          <div className={style.wallex__crypto__block}>
            <div className={style.wallex__crypto__title}>
              <WallexTitle size={'md'} state={state.cryptoBlockHeader.title} />
            </div>
            <div className={style.wallex__crypto__text}>
              {state.cryptoBlockHeader.text.text.map((item: any) => {
                return (
                  <div key={item} className={style.wallex__crypto__text__block}>
                    <WallexText state={item} />
                  </div>
                );
              })}
            </div>
            <div className={style.wallex__crypto__arrows}>
              {state.cryptoBlockHeader.arrows.map((item: any) => {
                return <CryptoArrow key={item.id} state={item} />;
              })}
            </div>
          </div>
          <div className={`${style.wallex__crypto__block} ${style.wallex__crypto__block_items}`}>
            <div className={style.wallex__crypto__item}>
              <CryptoItem state={state.cryptoBlock.Bitcoin} />
            </div>
            <div className={style.wallex__crypto__item}>
              <CryptoItem state={state.cryptoBlock.BitcoinCash} />
            </div>
            <div className={style.wallex__crypto__item}>
              <CryptoItem state={state.cryptoBlock.USDS} />
            </div>
            <div className={style.wallex__crypto__item}>
              <CryptoItem state={state.cryptoBlock.Stellar} />
            </div>
            <div className={style.wallex__crypto__item}>
              <CryptoItem state={state.cryptoBlock.GBPS} />
            </div>
            <div className={style.wallex__crypto__item}>
              <CryptoItem state={state.cryptoBlock.Ethereum} />
            </div>
            <div className={style.wallex__crypto__item}>
              <CryptoItem state={state.cryptoBlock.EURS} />
            </div>
          </div>
        </div>

        <hr />
        <div className={style.wallex__qoute}>
          <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
              if (inView) {
                entry?.target.classList.add(animations.active);
              }
              return (
                <div className={animations.scroll__animation} ref={ref}>
                  <Image alt={state.qouteBlock.alt} width="48" height="42" src={state.qouteBlock.qouteShape} />
                </div>
              );
            }}
          </InView>
          <div className={style.wallex__qoute__text}>
            <WallexTitleTwo state={state.qouteBlock.qoute} />
          </div>
          <div className={style.wallex__qoute__author}>
            <CryptoItem state={state.qouteBlock} />
          </div>
        </div>
      </div>
    </>
  );
};

export default WallexComponent;
